export var ENTITY = "property-cost";
export var REDUCER_KEY = "PROPERTY_COSTS_V2";
export var BASE_PATH_ENTITY = "property-costs";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
};
